import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAqlAyOBKzd05PY1ankeGu9u5ZfZ7JS2nI",
  authDomain: "safeguard-ng-44eca.firebaseapp.com",
  projectId: "safeguard-ng-44eca",
  storageBucket: "safeguard-ng-44eca.firebasestorage.app",
  messagingSenderId: "196799379281",
  appId: "1:196799379281:web:2e5562f4b20b24b3130570" // ✅ New Web App ID
};

const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
const auth = getAuth(app);
setPersistence(auth, browserLocalPersistence);
const db = getFirestore(app);
const storage = getStorage(app);

export { app, auth, db, storage };